import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { FeatureApi } from '../../api/FeatureApi';
import { updateTableData } from '../Helper/SliceDataHelper';

import type {
  ICreateMultiNumericFeatureRequest,
  ISearchRequest,
  IUpdateMultiNumericFeatureRequest,
  IDeleteMultiNumericFeatureRequest,
} from '../../../types/IRequestTypes';
import type { IMultiNumeric } from '../../../types/IComponentTypes';

const initialState: IMultiNumeric = {
  data: {},
  totalCount: 0,
  currentPage: 0,
  searchKey: '',
  recordsPerPage: 0,
};

//Feature thunks
//To get the paginated Feature data
export const getMultiNumericFeature = createAsyncThunk(
  'feature/getMultiNumericData',
  async (action: ISearchRequest) => {
    return FeatureApi.FetchMultiNumericFeature(action);
  }
);

//To update a Feature data
export const updateMultiNumericFeature = createAsyncThunk(
  'feature/updateMultiNumericData',
  async (action: { request: IUpdateMultiNumericFeatureRequest }) => {
    return FeatureApi.UpdateMultiNumericFeature(action);
  }
);

//To create a Feature data
export const createMultiNumericFeature = createAsyncThunk(
  'feature/createMultiNumericData',
  async (action: { request: ICreateMultiNumericFeatureRequest }) => {
    return FeatureApi.CreateMultiNumericFeature(action);
  }
);

//To delete a Feature data
export const deleteMultiNumericFeature = createAsyncThunk(
  'feature/deleteMultiNumericData',
  async (action: { request: IDeleteMultiNumericFeatureRequest[] }) => {
    // Assuming you might delete multiple at once
    return FeatureApi.DeleteMultiNumericFeature(action);
  }
);

const multiNumericSlice = createSlice({
  name: 'multiNumeric',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMultiNumericFeature.fulfilled, (state, action) => {
      if (!('error' in action.payload) && action.payload.currentPage) {
        return updateTableData(state, action.payload);
      }
      return state;
    });
  },
});

export default multiNumericSlice.reducer;
